import React, { useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { storages } from '../../../../store/slices'
import { useAppDispatch, useAppSelector } from '../../../../store'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { validation } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { navLinksProduct } from '../../../../services/product'
import { NumericField } from '../../../../components/numericField'

interface StorageEditPageProps {
    match: {
        params: {
            id: string
        }
    }
}

export function StorageEditPage(props: StorageEditPageProps): JSX.Element {
    useEffect(() => {
        dispatch(storages.actions.fetch())
    }, [])

    const dispatch = useAppDispatch()
    const history = useHistory()

    const storage = useAppSelector((state) => storages.selectors.selectById(state, props.match.params.id))

    const initialValues = {
        id: storage?.iri || '',
        name: storage?.name || '',
        lat: storage?.lat || null,
        long: storage?.long || null,
    }

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                dispatch(storages.actions.update({iri: values.id, data: values}))
                    .then(unwrapResult)
                    .then(() => {
                        history.goBack()
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksProduct}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Редактирование группы атрибутов'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        fullWidth
                                        validate={validation.required}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={NumericField}
                                        label="Широта"
                                        name="lat"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={NumericField}
                                        label="Долгота"
                                        name="long"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}